import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const SupportSection = () => {
  return (
    <section className="py-16 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto glass rounded-2xl p-8 md:p-10 text-center space-y-5"
        style={{ boxShadow: 'var(--shadow-glass)' }}
      >
        <div className="flex justify-center">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
            <MessageCircle className="w-7 h-7 text-primary" />
          </div>
        </div>
        
        <h2 className="text-2xl sm:text-3xl font-bold">
          Need Help?
        </h2>
        
        <p className="text-muted-foreground leading-relaxed">
          If you need assistance, reach out to us via the WhatsApp chat widget in the bottom right 
          of the screen, or email us directly at{' '}
          <a 
            href="mailto:support@xtreamcube.com" 
            className="text-primary hover:text-primary/80 font-medium transition-colors"
          >
            support@xtreamcube.com
          </a>
          . Our support team is here to help.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
          <Button
            variant="outline"
            className="glass border-primary/30 hover:bg-primary/10 text-foreground hover:text-foreground gap-2"
            onClick={() => window.open('https://wa.me/1234567890', '_blank')}
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp Chat
          </Button>
          
          <Button
            variant="outline"
            className="glass border-primary/30 hover:bg-primary/10 text-foreground hover:text-foreground gap-2"
            asChild
          >
            <a href="mailto:support@xtreamcube.com">
              <Mail className="w-5 h-5" />
              Email Support
            </a>
          </Button>
        </div>
      </motion.div>
    </section>
  );
};